import { dehydrate, QueryClient } from 'react-query'

import ProjectsApi from 'api/ProjectsApi'
import MetaTags from 'components/MetaTags'
import Portfolio from 'components/Portfolio'

import { portfolioMeta } from 'shared/constants'

export async function getServerSideProps() {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery(['portfolio-projects'], () =>
    ProjectsApi.getProjects({ expand: 'stats' }),
  )

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

const PortfolioPage = () => {
  return (
    <>
      <MetaTags data={portfolioMeta} />
      <Portfolio />
    </>
  )
}

export default PortfolioPage
